import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { AssignManagerStoreContext } from './contexts/StoreContext'
import { AssignManagerStoreProviderProps } from './interface'
import { createAssignManagerStore } from './store/createStore'

export const AssignManagerStoreProvider = ({
  children,
  /* -------------------------------------------------------------------------- */
  /*                      createAssignManagerStore Options                      */
  /* -------------------------------------------------------------------------- */
  tableRef
}: PropsWithChildren<AssignManagerStoreProviderProps>) => {
  const store = useCreation(() => createAssignManagerStore({ tableRef }), [])

  return (
    <AssignManagerStoreContext value={store}>
      {children}
    </AssignManagerStoreContext>
  )
}
